import { render, staticRenderFns } from "./AgentMigrationTool.vue?vue&type=template&id=2a66522a&scoped=true"
import script from "./AgentMigrationTool.vue?vue&type=script&lang=js"
export * from "./AgentMigrationTool.vue?vue&type=script&lang=js"
import style0 from "./AgentMigrationTool.vue?vue&type=style&index=0&id=2a66522a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a66522a",
  null
  
)

export default component.exports